var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-book"},[_c('input',{ref:"input",attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"input":_vm.onInput}}),_vm._t("default",function(){return [_c('div',{staticClass:"btn",on:{"click":_vm.btn}},[_vm._v(" "+_vm._s(_vm.text)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }